import xCircle from '@iconify/icons-heroicons-solid/x-circle';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';

import { PlaceholderView, PlaceholderViewProps } from '../Base';

export interface ErrorViewProps
  extends Omit<
    PlaceholderViewProps,
    'dataTestId' | 'icon' | 'mainText' | 'subText' | 'actionText'
  > {
  retry: () => void;
  cancel?: () => void;
}

export const ErrorView = ({
  retry,
  cancel,
  iconContainerClassName,
  ...baseProps
}: ErrorViewProps) => {
  const { t } = useTranslation();

  return (
    <PlaceholderView
      dataTestId="error-view"
      icon={xCircle}
      iconContainerClassName={twMerge(
        'bg-danger-50 text-danger-500',
        iconContainerClassName,
      )}
      mainText={t('errorView.defaultMainText')}
      subText={t('errorView.defaultSubText')}
      actionText={t('errorView.defaultRetryText')}
      subActionText={t('commons.cancel')}
      action={retry}
      subAction={cancel}
      {...baseProps}
    />
  );
};
